var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { size: "lg", "ok-disabled": _vm.isAdding },
      on: { ok: _vm.submitForm },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t(_vm.modalTitle)) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("company-address-form", {
            ref: "companyAddressForm",
            on: { finished: _vm.onFinish }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { slot: "modal-cancel" },
          on: {
            click: function($event) {
              _vm.showModal = false
            }
          },
          slot: "modal-cancel"
        },
        [_vm._v(_vm._s(_vm.$t("message.button.close")))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-ok" }, slot: "modal-ok" }, [
        _vm._v(
          _vm._s(
            _vm.isAdding
              ? _vm.$t("message.button.loading")
              : _vm.$t("message.button.save")
          )
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28357ca2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28357ca2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/companyAddress/CompanyAddressModal.vue
// module id = 1812
// module chunks = 0